import React, { useContext } from 'react';
import { FormattedDate } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Image } from '@vio/atlas/Image';
import placeHolderImage from '@vio/atlas/images/placeholder-hotel-image.svg';
import { StarRating } from '@vio/atlas/StarRating';
import { Text } from '@vio/atlas/Text';
import differenceInDays from 'date-fns/differenceInDays';
import parseISO from 'date-fns/parseISO';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
import { Room, RoomOffer } from '@findhotel/sapi';
import { ImageContext } from '../../context/ImageProviderContext';
import { getError } from '../../modules/selector';
import { ErrorMessage } from '../ErrorMessage';
import { Line } from './Line';
import { PriceSection } from './PriceSection';
import { RoomDetail } from './RoomDetail';
export interface Props {
  imageUrl: string;
  rating?: number;
  hotelName: string;
  checkIn: string;
  checkOut: string;
  roomsSplit: string;
  shouldShowPayNow: boolean;
  room?: Room | null;
  offer?: RoomOffer | null;
}
const MainWrapper = /*#__PURE__*/styled('div')({
  name: "MainWrapper",
  class: "mti2l0e",
  propsAsIs: false
});
const HotelAndRoomWrapper = /*#__PURE__*/styled('div')({
  name: "HotelAndRoomWrapper",
  class: "h490uh9",
  propsAsIs: false
});
const ImageContainer = /*#__PURE__*/styled('div')({
  name: "ImageContainer",
  class: "ih0fqn3",
  propsAsIs: false
});
const NameAndRatingContainer = /*#__PURE__*/styled('div')({
  name: "NameAndRatingContainer",
  class: "n15cy8ok",
  propsAsIs: false
});
const HotelInfo = /*#__PURE__*/styled('div')({
  name: "HotelInfo",
  class: "hxqchhs",
  propsAsIs: false
});
const CheckInOutWrapper = /*#__PURE__*/styled('div')({
  name: "CheckInOutWrapper",
  class: "cdngl0u",
  propsAsIs: false
});
const _exp9 = /*#__PURE__*/() => Text;
const DateText = /*#__PURE__*/styled(_exp9())({
  name: "DateText",
  class: "d1x90l85",
  propsAsIs: true
});
const _exp11 = /*#__PURE__*/() => Text;
const HotelTitle = /*#__PURE__*/styled(_exp11())({
  name: "HotelTitle",
  class: "h12v4nuj",
  propsAsIs: true
});
const ErrorWrapper = /*#__PURE__*/styled('div')({
  name: "ErrorWrapper",
  class: "eknhl3x",
  propsAsIs: false
});
export const HotelCard: React.FC<Props> = ({
  imageUrl,
  rating,
  hotelName,
  checkIn,
  checkOut,
  roomsSplit,
  room,
  offer,
  shouldShowPayNow
}) => {
  const imageProvider = useContext(ImageContext);
  const numberOfNights = differenceInDays(parseISO(checkOut), parseISO(checkIn));
  const {
    errored
  } = useSelector(getError);
  const shouldShowDetails = Boolean(!errored && room && offer);
  return <MainWrapper>
      <HotelAndRoomWrapper>
        <HotelInfo>
          <ImageContainer>
            <Image url={imageUrl} imageProvider={imageProvider} borderRadius="lg" placeHolderImage={placeHolderImage} />
          </ImageContainer>
          <NameAndRatingContainer>
            {rating && <StarRating rating={rating} size="xs" />}
            <HotelTitle variant="titleL">{hotelName}</HotelTitle>

            <CheckInOutWrapper>
              <DateText variant="bodyS">
                <FormattedDate value={dateStringToMiddayDate(checkIn)} month="short" day="2-digit" weekday="short" />
              </DateText>
              <Line width={38} />
              <DateText variant="bodyS">
                <FormattedDate value={dateStringToMiddayDate(checkOut)} month="short" day="2-digit" weekday="short" />
              </DateText>
            </CheckInOutWrapper>
          </NameAndRatingContainer>
        </HotelInfo>

        {shouldShowDetails && <RoomDetail room={room} offer={offer} roomsSplit={roomsSplit} numberOfNights={numberOfNights} />}
      </HotelAndRoomWrapper>

      {shouldShowDetails && <PriceSection shouldShowPayNow={shouldShowPayNow} />}

      {errored && <ErrorWrapper>
          <ErrorMessage />
        </ErrorWrapper>}
    </MainWrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");